module.exports = __webpack_public_path__ + "static/logo-s.ee37069e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/logo-s.svg
// module id = 104
// module chunks = 35783957827783 55213770944713 173894859265406